
import { useState, useEffect, useRef } from "react";
import { useAuthActions } from "@/hooks/auth";
import ReCAPTCHA from "react-google-recaptcha";
import EmailAuthForm from "./auth/EmailAuthForm";
import SocialAuthButton from "./auth/SocialAuthButton";
import AuthDivider from "./auth/AuthDivider";
import AuthModeToggle from "./auth/AuthModeToggle";
import ErrorDisplay from "./auth/ErrorDisplay";

const Auth = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  
  const {
    loading,
    error,
    handleGoogleLogin,
    handleEmailAuth,
    setupAuthListener
  } = useAuthActions();

  useEffect(() => {
    // Set up auth listener to handle redirects
    const subscription = setupAuthListener();
    return () => subscription.unsubscribe();
  }, [setupAuthListener]);

  const handleCaptchaReset = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setCaptchaToken(null);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    // Prevent default form submission behavior
    e.preventDefault();
    // Handle email authentication
    await handleEmailAuth(e, isSignUp, email, password, captchaToken, handleCaptchaReset);
  };

  const handleModeToggle = () => {
    handleCaptchaReset();
  };

  return (
    <div className="flex flex-col items-center space-y-6 w-full max-w-sm">
      <div className="w-full">
        <ErrorDisplay error={error} />
        
        <EmailAuthForm
          isSignUp={isSignUp}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          loading={loading}
          onSubmit={handleSubmit}
          captchaToken={captchaToken}
          setCaptchaToken={setCaptchaToken}
        />
        
        <AuthModeToggle 
          isSignUp={isSignUp} 
          setIsSignUp={setIsSignUp}
          onModeChange={handleModeToggle}
        />
      </div>
      
      <AuthDivider />
      
      <SocialAuthButton
        onGoogleLogin={handleGoogleLogin}
        loading={loading}
      />
    </div>
  );
};

export default Auth;
